import { MediaModel } from "../MediaModel";
import { ISongHistoryConfig } from "./types";

export class SongHistoryModel extends MediaModel {
    constructor(config: ISongHistoryConfig) {
        super(config);
    }
}